/* eslint-disable import/first */
import React from 'react';
import { useNavigate } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@material-ui/core';
import css from './index.module.scss';
import emptyIcon from './images/emptyCart.svg';
import { Redux, Slices } from 'spwa-ui-library';
const { getClusterId } = Slices.configSlice;

const { setCurrentCat } = Slices.categorySlice;
const { fetchProductsByCategoryId } = Slices.productSlice;
const { selectDefaultAddress } = Slices.addressSlice;

export default function EmptyCart(props) {
  const navigate = useNavigate();
  const dispatch = Redux.useDispatch();
  const intl = useIntl();

  const address = Redux.useSelector(selectDefaultAddress);
  const clusterId = Redux.useSelector(getClusterId);

  const handleNavigation = () => {
    if (props?.defaultPath) {
      const categoryId = props?.defaultPath?.split('/')?.[3];
      dispatch(setCurrentCat(categoryId));
      dispatch(
        fetchProductsByCategoryId({
          id: categoryId,
          cluster: clusterId,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          service: address.addressSubType || 'DELIVERY',
        })
      ).then((resp) => {
        navigate(props.defaultPath);
      });
    }
  };

  return (
    <div className={css.emptyRoot}>
      <div className={css.noItem}>
        <img src={emptyIcon} alt="cart is empty" />
        <h4>
          <FormattedMessage id="cart_empty" defaultMessage="Your Cart is Empty" />
        </h4>
        <p>
          <FormattedMessage
            id="cart_empty_desc"
            defaultMessage="Please add some items from the menu"
          />
        </p>
        <Button
          className={css.explore}
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          onClick={(e) => handleNavigation()}
        >
          <FormattedMessage id="explore_menu" defaultMessage="Explore Menu" />
        </Button>
      </div>
    </div>
  );
}
